// extracted by mini-css-extract-plugin
export default {"title":"other_work_projects_title__ZREbr","grid-view":"other_work_projects_grid-view__0Vs1-"};